import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDefaultRoute } from "../../hooks/useDefaultRoute";
import { usePermissions } from "../../hooks/usePermissions";

/**
 * Composant de redirection intelligente après connexion
 * Redirige l'utilisateur vers la page la plus appropriée selon ses permissions
 */
const LoginRedirect = () => {
  const navigate = useNavigate();
  const { user } = usePermissions();
  const { getPreferredRoute } = useDefaultRoute();

  useEffect(() => {
    if (user) {
      const currentUrl = sessionStorage.getItem("currentUrl");
      
      if (currentUrl && currentUrl !== "/login") {
        // Si l'utilisateur essayait d'accéder à une page spécifique, l'y rediriger
        sessionStorage.removeItem("currentUrl");
        navigate(currentUrl);
      } else {
        // Sinon, rediriger vers la page la plus appropriée selon le rôle
        const preferredRoute = getPreferredRoute();
        navigate(preferredRoute);
      }
    } else {
      // Si pas d'utilisateur, rediriger vers login
      navigate("/login");
    }
  }, [user, navigate, getPreferredRoute]);

  // Afficher un loading pendant la redirection
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirection en cours...</p>
      </div>
    </div>
  );
};

export default LoginRedirect;
